require('./style.less');

var ThumbView = require('../pgThumb');


module.exports = ThumbView.extend({

    template: require('./template.hbs'),

    NON_LOADING: 1,
    APPLY_TRANSFORM: 0,

    ui: _.extend( {}, ThumbView.prototype.ui, {
        launchBtn:  '.iconWr'
    }),

    serializeData: function() {
        return _.extend( ThumbView.prototype.serializeData.call(this), {
            url: this.model.getPageUrl()
        });
    },

    events: _.extend({}, ThumbView.prototype.events, {
        'click @ui.launchBtn': 'onBtnClick' /* look unintuitive if can't click */
    }),

    onBtnClick: function(e) {
        e.preventDefault();
        window.open(this.model.getPageUrl());
    }

});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/thumbnail/urlThumb/view.js
 ** module id = 567
 ** module chunks = 0
 **/